import { createContext } from "react";
import type { SiteSetting } from "../types";

export const defaultSiteSetting: SiteSetting = {
  activeFlights: new Set(),
  user: undefined,
  licenses: [],
};

export const PropertyContext = createContext<
  [SiteSetting, React.Dispatch<React.SetStateAction<SiteSetting>>]
  // eslint-disable-next-line @typescript-eslint/no-empty-function
>([defaultSiteSetting, () => {}]);
